import React from 'react';
import { useListContext, useRecordContext } from 'react-admin';
import { Box } from '@material-ui/core';

import { AppSecretType } from 'entities/AppSecretType';

import { AppSecretsDatagrid } from './AppSecretsDatagrid';
import { CreateWebhookSecretButton } from './CreateWebhookSecretButton';


export const AppSecretsBlock = (props) => {
	const { data, ids } = useListContext();
	const ownerRecord = useRecordContext();

	const presentTypes = new Set((ids || []).map((id) => data?.[id]?.type).filter(Boolean));
	const canAddWebhookSigning = ownerRecord && !presentTypes.has(AppSecretType.webhook_signing);

	return (
		<>
			<AppSecretsDatagrid {...props} />
			{canAddWebhookSigning && (
				<Box mt={2}>
					<CreateWebhookSecretButton oauthClientId={ownerRecord.id} />
				</Box>
			)}
		</>
	);
};
